import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sparkles } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/login", { replace: true }); return; }
    api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", "/");
        nav("/", { replace: true, state: { user: r.data } });
      })
      .catch(() => { nav("/login", { replace: true }); });
  }, [nav, setUser]);

  return (
    <div className="grid min-h-screen place-items-center bg-background">
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <div className="grid h-12 w-12 animate-pulse place-items-center rounded-xl bg-primary text-white"><Sparkles size={22} /></div>
        Signing you in...
      </div>
    </div>
  );
}
